module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/135.0c5b0f7c.png";